import React from 'react'
import styled from '@emotion/styled'
import { Link } from '@reach/router'
import { colors } from 'style/theme'
import { Popover, Button, Icon } from 'antd'
import TimeAgo from 'react-timeago'

const StyledUsersPopoverContent = styled.div({
  minWidth: 200
})

const StyledUser = styled.div({
  color: colors.brandText,
  fontWeight: 700,
  fontSize: 14,
})

const MoreCount = styled.div({
  backgroundColor: '#F4FAFF',
  border: `1px solid ${colors.brand}`,
  borderRadius: '50%',
  height: 24,
  width: 24,
  lineHeight: '24px',
  textAlign: 'center',
  color: colors.brand,
  fontSize: "0.9rem",
  margin: "0 auto",
})

const ProjectsPopoverContent = ({ projects }) => {
  return (
    projects && (
      <StyledUsersPopoverContent>
        {projects.map((project, i) => {
          return (
            <StyledUser>{project.name}</StyledUser>
          )
        })}
      </StyledUsersPopoverContent>
    )
  )
}

const StyledCol = styled.span({
  fontWeight: 700,
  fontSize: 14
})

const StyledEmail = styled.span({
  color: colors.brandTextLight,
  fontWeight: 700,
  fontSize: 12
})

const StyledRole = styled.span({
  color: colors.brandLink,
  fontWeight: 500,
  fontSize: 12,
  textTransform: 'uppercase'
})

const StyledDate = styled(StyledCol)({
  color: colors.brandTextLight
})

const Resend = styled(Button)({
  fontWeight: 400,
  padding: 0,
  textAlign: 'left',
  fontWeight: 700
})

const StyledLink = styled.div({
  fontWeight: 700,
  color: colors.brandLink,
  textAlign: 'left'
})


function UserListColumns(inviteUsers) {
  return [
    {
      title: 'NAME',
      width: '30%',
      dataIndex: 'name',
      render(name, record) {
        return (
          <StyledCol>
            {name} {record.surname}
          </StyledCol>
        )
      }
    },
    {
      title: 'EMAIL',
      dataIndex: 'email',
      render(email) {
        return <StyledEmail>{email}</StyledEmail>
      }
    },
    {
      title: 'ACCOUNT ROLE',
      dataIndex: 'role',
      render(role) {
        return <StyledRole>{role}</StyledRole>
      }
    },
    {
      title: 'PROJECTS',
      align: 'center',
      dataIndex: 'projects',
      render(projects, record) {
        return record.role && record.signup_date ? (
          <Popover content={<ProjectsPopoverContent projects={projects} />}>
          <MoreCount>{projects.length}</MoreCount>
        </Popover>
        ) : (
          <span></span>
        )
      }
    },
    {
      title: 'SIGNUP DATE',
      dataIndex: 'signup_date',
      render(signupDate) {
        return (
          <StyledDate>
            <TimeAgo date={signupDate} />
          </StyledDate>
        )
      }
    },
    {
      dataIndex: 'role',
      width: 200,
      key: 'actions',
      render(role, record) {
        return role && record.signup_date ? (
          <StyledLink>
            <Icon type="eye" />&nbsp;&nbsp;
            <Link to={`${record.id}/permissions?n=${record.name} ${record.surname}`}>VIEW PERMISSIONS</Link>
          </StyledLink>
        ) : (
          <Resend type="link" icon="mail" onClick={() => inviteUsers({ data: [{ email: record.email, is_account_admin: false }] })}>
            RESEND INVITE
          </Resend>
        )
      }
    }
  ]
}

export default UserListColumns
